//#region IMPORT
import React from 'react';
/** Components Import */
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton } from '../../../../Components/MUIs';
/** AG-grid Import */
import dayjs from 'dayjs';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import GridCheckBox from '../../../../Components/Ui/GridCheckBox/GridCheckBox';

function AIM_BASIC(props) {
  //#region 웹(컬럼 세팅)
  const columnDefs1 = [
    {
      field: 'no',
      headerName: 'NO',
      maxWidth: 80,
      cellStyle: {
        textAlign: 'right',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      editable: false,
      cellClass: 'delete-action-cell',
      cellRenderer: (params) => {
        return (
          <GridCheckBox
            params={params}
            DeleteNewRow={props.DeleteNewRow1}
            RestoreRow={props.RestoreRow1}
            gridRef={props.gridRef1}
            rowData={props.rowData1}
            selectedRowNosRef={props.selectedRowNosRef1}
            lastCheckedIndexRef={props.lastCheckedIndexRef1}
            handleRowSelection={props.handleRowSelection1}
          />
        );
      },
      // rowDrag: true,
      rowDrag: (params) => params.data?.deleteYn !== 'Y', // ✅ deleteYn === 'Y'이면 비활성
    },
    {
      field: 'CUST_CD',
      headerName: '사업장코드',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'AI_MESSAGE_CD',
      headerName: '보이스 체크 메세지 코드',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'GUBUN',
      headerName: '구분',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'AI_LAN',
      headerName: '언어',
      minWidth: 100,
      editable: false,
      hide: true,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
    },
    {
      field: 'MESSAGE',
      headerName: '보이스 체크 내용',
      flex: 1,
      editable: true,
      sortable: false,
      cellStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }, // 셀 자체 왼쪽 정렬
      cellClassRules: {
        'required-cell': (params) =>
          !params.value || params.value.trim() === '',
      },
    },
  ];
  //#endregion

  //#region 함수

  //#endregion

  return (
    <Grid
      container
      spacing={2}
      columns={{ xs: 4, sm: 8, md: 12 }}
      sx={{ height: '100%' }}
    >
      <Grid xs={4} md={12} sx={{ height: '100%' }}>
        <AuthButton
          menuId="AicallManager"
          searchYn="Y"
          addYn="Y"
          saveYn="Y"
          searchClick={(e) => {
            props.searchRef.current.searchText = e;
            props.SearchLogic1();
          }}
          saveClick={() => props.SaveLogic1()}
          conditions={[
            {
              type: 'combo',
              name: '사업장',
              items: props.searchRef.current.custList,
              value: props.searchRef.current.custCd,
              onChange: (e) => {
                props.searchRef.current = {
                  ...props.searchRef.current,
                  custCd: e,
                };
                props.SearchLogic1();
              },
            },
          ]}
          placeholder="보이스 체크 내용"
          grids={
            <BusinessCommon
              getRowId={(params) => {
                return params.data.no;
              }}
              addYn1={'Y'}
              deleteYn={'Y'}
              rowDragManaged={true}
              pagination={false}
              addClick1={() => {
                props.HandleAddClick(props.gridRef1);
              }}
              refreshClick1={() => {
                props.SearchLogic1();
                props.SearchLogic2();
              }}
              deleteClick1={(e) => {
                const newRowExists = props.selectedRowData1.some(
                  (row) => row.newYn === 'Y'
                );

                if (!newRowExists) {
                  props.MarkedForDeletion1(props.selectedRowData1);
                } else {
                  props.NewYnErrorMsg();
                }
              }}
              gridRef={props.gridRef1}
              columnDefs={columnDefs1}
              rowData={props.rowData1}
              setSelectedRowData={props.setSelectedRowData1}
              setChangedRowData={props.setChangedRowData1}
              tableData={props.tableData1}
              title1="안전관리자 및 보건관리자 기본정보"
              title2="안전관리자 및 보건관리자 상세정보"
              onSelectionChanged={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.selectedRowNosRef1.current = new Set(
                  selectedData.map((r) => r.no)
                );
                props.setSelectedRowData1(selectedData);
              }}
              onCellValueChanged={(e) => {
                const key = e.data.no;

                props.setChangedRowData1?.((prev) => {
                  const filtered = prev.filter((row) => row.no !== key);
                  return [...filtered, { ...e.data }];
                });
              }}
              onRowDragEnd={(e) => {
                let dragRowData = [];
                // 이전에 선택된 row의 키 저장
                const selectedKeys = new Set(
                  props.selectedRowData1.map((row) => row.no)
                );

                const gridApi = props.gridRef1?.current?.api;
                gridApi.forEachNode((node, index) => {
                  dragRowData.push({
                    ...node.data,
                    no: index + 1,
                    orgNo: node.data.no,
                  });
                });

                props.setRowData1(dragRowData);
                props.setChangedRowData1(dragRowData);

                // 선택 상태 복원 — orgNo가 이전에 선택된 키에 포함된 경우 선택
                props.selectedRowNosRef1.current = new Set(
                  dragRowData
                    .filter((item) => selectedKeys.has(item.orgNo))
                    .map((r) => r.no)
                );

                // 여기서 그리드 행 선택 상태를 직접 설정
                gridApi.forEachNode((node) => {
                  const shouldSelect = props.selectedRowNosRef1.current.has(
                    node.data.no
                  );
                  node.setSelected(shouldSelect, true); // 두번째 인자는 이벤트 발생 여부(false는 안 발생)
                });

                // 선택된 행 데이터 React 상태에 저장
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);
                props.setSelectedRowData1(selectedData);
              }}
            />
          }
        />
      </Grid>
    </Grid>
  );
}

export default AIM_BASIC;
